declare const SystemJS: any

if (typeof SystemJS !== 'undefined' && typeof SystemJS.decanonicalize === 'undefined') {
  const resolve =
    SystemJS.resolveSync ||
    (SystemJS.normalizeSync &&
      ((key: string, parentKey?: string) => SystemJS.normalizeSync(key, parentKey))) ||
    ((key: string) => key)

  SystemJS.decanonicalize = resolve as typeof SystemJS.decanonicalize

  try {
    const proto = SystemJS.constructor && SystemJS.constructor.prototype
    if (proto && typeof proto.decanonicalize === 'undefined') {
      proto.decanonicalize = resolve as typeof SystemJS.decanonicalize
    }
  } catch (_) {
    // ignore
  }
}
